<template>
  <div>
    <Button size="large" class="addbutton" @click="CheckHistoryPicture">检查历史事件图片</Button>
    <Button size="large" class="addbutton" @click="CheckRecipeStepPicture">检查菜谱步骤图片</Button>
  </div>
</template>

<script>
import {Button} from "mint-ui";

export default {
  name: "CheckPicture",
  components: {
    Button
  },
  data() {
    return {
      token: localStorage.getItem('token'),
      checkHistoryPictureUrl: '/api/otherapi/checkHistoryPicture',
      checkRecipeStepPictureUrl: '/api/otherapi/checkRecipeStepPicture',
    }
  },
  methods: {
    async CheckHistoryPicture() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.checkHistoryPictureUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async CheckRecipeStepPicture() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.checkRecipeStepPictureUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.addbutton {
  background: lightseagreen;
  margin-bottom: 0.5rem;
}
</style>
